function messageFrameToBottom() {
	var frameHeight = 0;

	$(".dialog__frame")
		.children()
		.each(function() {
			frameHeight = frameHeight + $(this).outerHeight(true);
		});
	$(".dialog__frame").scrollTop(frameHeight);
	$(".dialog__frame").addClass('active');
}